<template functionnal>
  <v-layout class="align-center">
    <div class="outer">
      <div class="inner" />
      <div class="inner" />
      <div class="inner" />
    </div>
    <div class="pole" />
  </v-layout>
</template>

<style lang="scss" scoped>
  .outer{
    width: 50px;
    height: 25px;
    border: 3px solid #fff;
    display: flex;
    padding: 2px;
    border-radius: 2px;
    transition: all 0.3s;
  }
  .inner{
    height: 100%;
    background-color: #fff;
    flex: 1;
    border-radius: 0.2px;
    opacity: 0;
    animation: ani1 2.5s infinite;
  }
  .inner:nth-child(2){
    margin: 0 1px;
    animation: ani2 2.5s infinite;
  }
  .inner:nth-child(3){
    animation: ani3 2.5s infinite;
  }
  .pole{
    width: 4px;
    height: 10px;
    border-radius: 0 1px 1px 0;
    background-color: #fff;
  }

  @keyframes ani1{
    33%, 100%{
      opacity: 1;
    }
  }
  @keyframes ani2{
    0%, 33%{
      opacity: 0;
    }
    66%, 100%{
      opacity: 1;
    }
  }
  @keyframes ani3{
    0%, 66%{
      opacity: 0;
    }
    100%{
      opacity: 1;
    }
  }
</style>
